/* prettier-ignore */

import { Injectable, inject } from '@angular/core';
import { ChatStylesRequest } from '../interface/chatStyles.interface';
import { dataChatService } from './dataChat.service';

@Injectable({providedIn: 'root'})
export class CssStylesService {
  public dataChat = inject(dataChatService)

  getGlobalStyle(res: ChatStylesRequest): void {
    let stylesProperties = res.data;
    Object.keys(stylesProperties).forEach((styleProperty) => {
      const valor = stylesProperties[styleProperty];
      if (styleProperty in this.dataChat.chatStyles)
        this.dataChat.chatStyles[styleProperty] = valor;
    });
  }

  setCSSVariables(): void {
    let buttonColorDisabled: string = this.getSecondaries(
      this.dataChat.chatStyles.button_color!,
      0.5,
      false
    );
    const userMessageColorSecondary: string = this.getSecondaries(
      this.dataChat.chatStyles.user_message_color!,
      0.03
    );
    document.documentElement.style.setProperty(
      '--header_color',
      this.dataChat.chatStyles.header_color || '#000'
    );
    document.documentElement.style.setProperty(
      '--text_header_color',
      this.dataChat.chatStyles.text_header_color || '#000'
    );
    document.documentElement.style.setProperty(
      '--user_text_color',
      this.dataChat.chatStyles.user_text_color || '#000'
    );
    document.documentElement.style.setProperty(
      '--user_border_color',
      this.dataChat.chatStyles.user_border_color || '#EF6A47'
    );
    document.documentElement.style.setProperty(
      '--user_message_color',
      this.dataChat.chatStyles.user_message_color || '#EF6A47'
    );
    document.documentElement.style.setProperty(
      '--user_message_color_secondary',
      userMessageColorSecondary
    );
    document.documentElement.style.setProperty(
      '--user-message-arrow',
      this.dataChat.chatStyles.user_message_color || '#EF6A47'
    );
    document.documentElement.style.setProperty(
      '--user_gradient_1',
      this.dataChat.chatStyles.user_gradient_1 || '#000'
    );
    document.documentElement.style.setProperty(
      '--bot_text_color',
      this.dataChat.chatStyles.bot_text_color || '#EF6A47'
    );
    document.documentElement.style.setProperty(
      '--bot_message_color',
      this.dataChat.chatStyles.bot_message_color || '#fff'
    );
    document.documentElement.style.setProperty(
      '--bot-message-arrow',
      this.dataChat.chatStyles.bot_message_color || '#EF6A47'
    );
    document.documentElement.style.setProperty(
      '--bot_gradient_1',
      this.dataChat.chatStyles.bot_gradient_1 || '#000'
    );
    document.documentElement.style.setProperty(
      '--bot_border_color',
      this.dataChat.chatStyles.bot_border_color || 'transparent'
    );
    document.documentElement.style.setProperty(
      '--button_color',
      this.dataChat.chatStyles.button_color || '#EF6A47'
    );
    document.documentElement.style.setProperty(
      '--button_color_disabled',
      buttonColorDisabled
    );
    document.documentElement.style.setProperty(
      '--background_color',
      this.dataChat.chatStyles.background_color || '#dddddd'
    );

    if (this.dataChat.chatStyles.user_gradient_1) {
      document.documentElement.style.setProperty(
        '--user-message-arrow',
        this.dataChat.chatStyles.user_gradient_1
      );
    }

    if (this.dataChat.chatStyles.bot_gradient_1) {
      document.documentElement.style.setProperty(
        '--bot-message-arrow',
        this.dataChat.chatStyles.bot_gradient_1
      );
    }
  }

  getSecondaries(hex: string, factor: number, darken = true): string {
    // Validar que el argumento hex sea un string de 6 caracteres
    if (!/^(#)?([0-9a-fA-F]{6})$/.test(hex)) {
      return 'Formato de color hexadecimal no válido';
    }

    // Quitar el posible símbolo "#" del principio
    hex = hex.replace('#', '');

    // Convertir a valores RGB
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);

    // Modificar los componentes RGB según la operación deseada
    if (darken) {
      r = Math.floor(r * (1 - factor));
      g = Math.floor(g * (1 - factor));
      b = Math.floor(b * (1 - factor));
    } else {
      r = Math.floor(r + (255 - r) * factor);
      g = Math.floor(g + (255 - g) * factor);
      b = Math.floor(b + (255 - b) * factor);
    }

    // Asegurarse de que los valores estén en el rango correcto (0-255)
    r = Math.min(255, Math.max(0, r));
    g = Math.min(255, Math.max(0, g));
    b = Math.min(255, Math.max(0, b));

    // Convertir de nuevo a formato hexadecimal
    var nuevoColorHex = ((1 << 24) + (r << 16) + (g << 8) + b)
      .toString(16)
      .slice(1);

    return '#' + nuevoColorHex;
  }

}
